import PropTypes from 'prop-types';

const HealthIcon = ({ size, fill, ...other }) => (
  <div style={{ fontSize: size }} {...other}>
    <svg width="1em" height="1em" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M42.846 3h1.308A3.846 3.846 0 0 1 48 6.846v34.308A3.846 3.846 0 0 1 44.154 45h-1.308A3.846 3.846 0 0 1 39 41.154V6.846A3.846 3.846 0 0 1 42.846 3zm-13 7h1.308A3.846 3.846 0 0 1 35 13.846v27.308A3.846 3.846 0 0 1 31.154 45h-1.308A3.846 3.846 0 0 1 26 41.154V13.846A3.846 3.846 0 0 1 29.846 10zm-13 10h1.308A3.846 3.846 0 0 1 22 23.846v17.308A3.846 3.846 0 0 1 18.154 45h-1.308A3.846 3.846 0 0 1 13 41.154V23.846A3.846 3.846 0 0 1 16.846 20zm-13 8h1.308A3.846 3.846 0 0 1 9 31.846v9.308A3.846 3.846 0 0 1 5.154 45H3.846A3.846 3.846 0 0 1 0 41.154v-9.308A3.846 3.846 0 0 1 3.846 28z"
        fill={fill}
        fillRule="evenodd"
      />
    </svg>
  </div>
);

HealthIcon.propTypes = {
  size: PropTypes.string,
  fill: PropTypes.string,
};

HealthIcon.defaultProps = {
  size: 'inherit',
  fill: 'currentColor',
};

export default HealthIcon;
